var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.showLanguageSelector
    ? _c(
        "div",
        { staticClass: "align-items-center d-flex relative" },
        [
          _c(
            "b-dropdown",
            {
              staticClass: "language-selector text-gray-400",
              attrs: { variant: "light", right: "" },
              scopedSlots: _vm._u(
                [
                  {
                    key: "button-content",
                    fn: function () {
                      return [
                        _c("span", {
                          staticClass: "show-flag shadow-sm",
                          domProps: {
                            innerHTML: _vm._s(_vm.getFlag(_vm.language.flag)),
                          },
                        }),
                      ]
                    },
                    proxy: true,
                  },
                ],
                null,
                false,
                2254157120
              ),
              model: {
                value: _vm.locale,
                callback: function ($$v) {
                  _vm.locale = $$v
                },
                expression: "locale",
              },
            },
            [
              _vm._v(" "),
              _vm._l(_vm.langs, function (lang) {
                return _c(
                  "b-dropdown-item",
                  {
                    key: lang.key,
                    on: {
                      click: function ($event) {
                        _vm.locale = lang.key
                      },
                    },
                  },
                  [
                    _c(
                      "span",
                      { staticClass: "d-flex align-items-center gap-2" },
                      [
                        _c("span", {
                          staticClass: "flag-list",
                          domProps: {
                            innerHTML: _vm._s(_vm.getFlag(lang.flag)),
                          },
                        }),
                        _vm._v(" "),
                        _c("span", { staticClass: "language-label" }, [
                          _vm._v(_vm._s(lang.label)),
                        ]),
                      ]
                    ),
                  ]
                )
              }),
            ],
            2
          ),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }